import { createStore } from 'satcheljs';
import { CalendarEventsFilterStore } from './schema/CalendarEventsFilterStore';
import { CalendarEventsFilters } from '../utils/CalendarEventsFilters';

const defaultStore: CalendarEventsFilterStore = {
    currentFilters: [CalendarEventsFilters.All],
};

export const getStore = createStore<CalendarEventsFilterStore>(
    'CalendarEventsFilterStore',
    defaultStore
);
